module.exports = __webpack_public_path__ + "static/img/zlws_adv_w.51c96f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zlws_adv_w.png
// module id = Zzvo
// module chunks = 1